<template>
  <v-card :class="{ 'ma-3': !xs, 'mx-auto': xl }" style="border-radius: 0; max-width: 1880px">
    <v-img
      :src="currImage"
      class="currImage white--text align-end"
      style="background-color: rgba(0, 0, 0, 0.6)"
      v-touch="{
        left: () => swipe('Left'),
        right: () => swipe('Right'),
      }"
      contain
    >
      <v-card-title
        :class="{
          withGradient: currDescription ? currDescription.length == 0 : true,
          withoutGradient: currDescription ? currDescription.length > 0 : false,
        }"
      >
        {{ currDescription }}
        <v-spacer></v-spacer>
        <span style="font-size: medium">{{ currIndex + 1 }}/{{ images.length }}</span>
      </v-card-title>
    </v-img>
    <v-btn class="nav-prev" @click="prevImage()" fab small>
      <v-icon dark> mdi-chevron-left</v-icon>
    </v-btn>
    <v-btn class="nav-next" @click="nextImage()" fab small>
      <v-icon dark> mdi-chevron-right</v-icon>
    </v-btn>
  </v-card>
</template>

<script>
import { mapState } from 'vuex';
import commonMixin from '@/mixins/common';
import config from '@/common/config';
import index from '@/modules/gallery/index';

export default {
  name: 'GalleryCarousel',
  mixins: [commonMixin],
  data() {
    return {
      model: null,
      length: 3,
      onboarding: 0,
      currIndex: 0,
    };
  },
  mounted() {
    if (this.$route.query.imageIndex !== undefined) {
      this.currIndex = parseInt(this.$route.query.imageIndex);
    } else {
      let imageId = Number(this.$route.params.imageId);
      if (imageId) {
        let index = this.images.findIndex((i) => i.id === imageId);
        if (index) {
          this.currIndex = index;
          this.model = index;
        }
      }
    }
    this.$store.dispatch('gallery/markAsRead', this.gallery);

    window.addEventListener('keydown', this.switchImage);
  },
  beforeDestroy() {
    window.removeEventListener('click', this.switchImage);
  },
  computed: {
    ...mapState('gallery', ['galleriesById']),
    gallery() {
      let gallery = this.galleriesById[this.$route.params.galleryId];
      if (!gallery) {
        console.debug('No gallery with id=this.$route.params.galleryId', this.$route.params.galleryId);
        return {};
      }
      console.debug('found gallery', gallery);
      return gallery;
    },
    images() {
      return this.gallery._images ? this.gallery._images.slice().sort((a, b) => a.sort - b.sort) : [];
    },
    currImage() {
      if (this.images[this.currIndex]) {
        return this.imageUrl(this.images[this.currIndex]);
      }
      return '';
    },
    currDescription() {
      if (this.images[this.currIndex]) {
        return this.images[this.currIndex].description;
      }
      return '';
    },
  },
  methods: {
    imageUrl(image) {
      return `${config.apiUrl}/medias/${index.api}/${image.filename}/${image.checksum}`;
    },
    prevImage() {
      if (this.currIndex - 1 < 0) {
        this.currIndex = this.images.length - 1;
      } else {
        this.currIndex--;
      }
    },
    nextImage() {
      if (this.currIndex + 1 > this.images.length - 1) {
        this.currIndex = 0;
      } else {
        this.currIndex++;
      }
    },
    switchImage(evt) {
      if (evt.key == 'ArrowLeft') {
        this.prevImage();
      }
      if (evt.key == 'ArrowRight') {
        this.nextImage();
      }
    },
    swipe(direction) {
      if (direction == 'left') {
        this.prevImage();
      }
      if (direction == 'right') {
        this.nextImage();
      }
    },
  },
};
</script>

<style scoped>
.withGradient {
  background: linear-gradient(90deg, rgba(0, 0, 0, 0) 75%, rgba(0, 0, 0, 0.6) 100%);
}
.withoutGradient {
  background: rgba(0, 0, 0, 0.6);
}
.nav-prev {
  position: absolute;
  left: 12px;
  top: 50%;
  margin-top: -19px;
}
.nav-next {
  position: absolute;
  right: 12px;
  top: 50%;
  margin-top: -19px;
}
.description-light,
.description-dark {
  display: flex;
  justify-content: center;
  font-size: 1.4rem;
  padding: 4px 20px;
  text-align: center;
}

.v-item-group {
  min-height: 420px;
}

.page {
  position: absolute;
  bottom: 30%;
  left: 0;
  right: 0;
  text-align: center;
}

.description-dark {
  color: white;
}

.description-light {
  color: black;
}
</style>

<style type="text/css">
.v-image__image--contain {
  transition: all 0.25s linear;
}
</style>
